import React, { memo } from 'react';
import { Field, useFormikContext } from 'formik';
import get from 'lodash/get';

import RenderInput from '../RenderInput/RenderInput';

export type TextFieldConfig = {
    name: string;
    label: string;
    required?: boolean;
    helperText?: string;
    multiline?: boolean;
    rows?: number;
    fullWidth?: boolean;
    disabled?: boolean;
    disableHelperText?: boolean;
    formControlClassName?: string;
};

type Props = { fields: TextFieldConfig[] };
function TextFieldsOnBlur<T = any>({ fields }: Props) {
    const { values, setFieldValue, handleBlur } = useFormikContext<T>();
    return (
        <>
            {fields.map((field, i) => {
                const { name } = field;
                const defaultValue = get(values, name, '');
                const onBlur = (ev: React.FocusEvent<HTMLInputElement>) => {
                    const newValue = ev.target?.value?.trim();
                    setFieldValue(name, newValue);
                    handleBlur(ev);
                };
                return (
                    <Field
                        {...field}
                        type="text"
                        key={`${name}-${defaultValue}-${i}`}
                        defaultValue={defaultValue}
                        component={RenderInput}
                        field={{ name, onBlur }}
                    />
                );
            })}
        </>
    );
}

export default memo(TextFieldsOnBlur);
